import { render, staticRenderFns } from "./ShopHelicopterDetails.vue?vue&type=template&id=ba086ab0&scoped=true&"
import script from "./ShopHelicopterDetails.vue?vue&type=script&lang=js&"
export * from "./ShopHelicopterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopHelicopterDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopHelicopterDetails.vue?vue&type=style&index=1&id=ba086ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba086ab0",
  null
  
)

export default component.exports